import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'tidy-pill-button',
  templateUrl: './pill-button.component.html',
  styleUrls: ['./pill-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TidyPillButtonComponent {
  @Input() image = '';
  @Input() text = '';
  @Input() noHover = false;
  @Output() buttonClick = new EventEmitter<void>();
}
